// extracted by mini-css-extract-plugin
var _1 = "styles_container__jYK8e";
var _2 = "styles_stars__KYyqf";
var _3 = "styles_subtitle__4KwHV";
var _4 = "styles_title__iSt7y";
export { _1 as "container", _2 as "stars", _3 as "subtitle", _4 as "title" }
